<template>
  <div class="relative flex flex-col justify-center w-full">
    <form
      class="w-full space-y-6"
      @submit.prevent="next"
      @keydown.right.prevent="next"
      @keydown.enter.prevent="next"
      @keydown.esc.prevent="close"
    >
      <h2
        @click="showTooltip = !showTooltip"
        class="text-2xl font-bold text-bright-gray dark:text-white lg:text-4xl"
      >
        {{ item.questionDisplay }}
        <span v-if="item.required" class="text-ruby">*</span>
      </h2>

      <div class="flex flex-col space-y-4">
        <div class="relative mt-1 rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 flex items-center pl-3 text-black pointer-events-none dark:text-white"
          >
            <svg class="w-8 h-8 fill-current" viewBox="0 0 20 20">
              <path
                id="Path_53"
                data-name="Path 53"
                d="M12,2a10.066,10.066,0,0,0-1.562,20V14.968H7.9V12.061h2.54V9.844c0-2.521,1.492-3.914,3.777-3.914a15.3,15.3,0,0,1,2.238.2V8.6h-1.26a1.45,1.45,0,0,0-1.63,1.572v1.887h2.773l-.443,2.908h-2.33V22A10.066,10.066,0,0,0,12,2Z"
                transform="translate(-2 -2)"
              />
            </svg>
          </div>
          <input
            type="text"
            name="fb"
            v-focus
            v-model="selected.fb"
            class="flex pl-[60px] rounded-lg w-full h-[60px] text-xl border-gold dark:text-white dark:bg-[#1b1c20] dark:border-gold focus:ring-0 border-2 focus focus:border-gold"
          />
        </div>
        <div class="relative mt-1 rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 flex items-center pl-3 text-black pointer-events-none dark:text-white"
          >
            <svg class="w-8 h-8 fill-current" viewBox="0 0 20 20">
              <path
                id="Path_56"
                data-name="Path 56"
                d="M12,2c2.717,0,3.056.01,4.122.06a7.367,7.367,0,0,1,2.428.465,4.876,4.876,0,0,1,1.772,1.153A4.908,4.908,0,0,1,21.475,5.45a7.387,7.387,0,0,1,.465,2.428C21.987,8.944,22,9.283,22,12s-.01,3.056-.06,4.122a7.393,7.393,0,0,1-.465,2.428,5.106,5.106,0,0,1-2.925,2.925,7.387,7.387,0,0,1-2.428.465c-1.066.047-1.4.06-4.122.06s-3.056-.01-4.122-.06a7.393,7.393,0,0,1-2.428-.465A5.106,5.106,0,0,1,2.525,18.55a7.361,7.361,0,0,1-.465-2.428C2.013,15.056,2,14.717,2,12s.01-3.056.06-4.122A7.361,7.361,0,0,1,2.525,5.45,4.88,4.88,0,0,1,3.678,3.678,4.9,4.9,0,0,1,5.45,2.525,7.361,7.361,0,0,1,7.878,2.06C8.944,2.013,9.283,2,12,2Zm0,5a5,5,0,1,0,5,5A5,5,0,0,0,12,7Zm6.5-.25A1.25,1.25,0,1,0,17.25,8,1.25,1.25,0,0,0,18.5,6.75ZM12,9a3,3,0,1,1-3,3A3,3,0,0,1,12,9Z"
                transform="translate(-2 -2)"
              />
            </svg>
          </div>
          <input
            type="text"
            name="ig"
            v-model="selected.ig"
            class="flex pl-[60px] rounded-lg w-full h-[60px] text-xl border-gold dark:text-white dark:bg-[#1b1c20] dark:border-gold focus:ring-0 border-2 focus focus:border-gold"
          />
        </div>
        <div class="relative mt-1 rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 flex items-center pl-3 text-black pointer-events-none dark:text-white"
          >
            <svg class="w-8 h-8 fill-current" viewBox="0 0 20 20">
              <path
                id="Path_60"
                data-name="Path 60"
                d="M20.039,20.043H17.078V15.4c0-1.107-.022-2.531-1.544-2.531-1.543,0-1.779,1.2-1.779,2.45v4.722H10.792V10.5h2.844v1.3h.039a3.124,3.124,0,0,1,2.809-1.541c3,0,3.556,1.976,3.556,4.546v5.239ZM7.448,9.194a1.72,1.72,0,1,1,1.72-1.719,1.718,1.718,0,0,1-1.72,1.719ZM8.932,20.043H5.962V10.5H8.933v9.543ZM21.522,3H4.477A1.457,1.457,0,0,0,3,4.441V21.559A1.458,1.458,0,0,0,4.476,23H21.518A1.464,1.464,0,0,0,23,21.559V4.441A1.464,1.464,0,0,0,21.518,3h0Z"
                transform="translate(-3 -3)"
              />
            </svg>
          </div>
          <input
            type="text"
            name="ln"
            v-model="selected.in"
            class="flex pl-[60px] rounded-lg w-full h-[60px] text-xl border-gold dark:text-white dark:bg-[#1b1c20] dark:border-gold focus:ring-0 border-2 focus focus:border-gold"
          />
        </div>
        <div class="relative mt-1 rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 flex items-center pl-3 text-black pointer-events-none dark:text-white"
          >
            <Twitter class="w-8 h-8 text-vulcan dark:text-white fill-current" />
          </div>
          <input
            type="text"
            name="tw"
            v-model="selected.tw"
            class="flex pl-[60px] rounded-lg w-full h-[60px] text-xl border-gold dark:text-white dark:bg-[#1b1c20] dark:border-gold focus:ring-0 border-2 focus focus:border-gold"
          />
        </div>
      </div>

      <!-- Desktop action -->
      <div
        class="flex-col justify-between hidden w-full pt-4 md:flex md:w-full md:flex-row"
      >
        <div class="flex flex-row space-x-4">
          <button
            type="button"
            @click="next"
            class="inline-flex items-center justify-center flex-shrink-0 min-w-0 px-8 py-2 text-sm font-bold text-center text-black rounded-full bg-gold-alt focus:outline-none"
          >
            <span v-if="!isLoading">{{ t("input.continue") }}</span>
            <span v-else class="flex flex-row space-x-4"
              ><span>{{ t("input.saving") }}</span>
              <Spinner text-color="text-black"
            /></span>
          </button>
          <button
            type="submit"
            class="inline-flex items-center justify-center px-8 py-2 space-x-1 text-sm font-bold text-white rounded-full focus:outline-none"
          >
            <span class="text-navada">press</span>
            <span class="text-black dark:text-white">{{
              t("input.enter")
            }}</span>
            <span>
              <ReturnIcon />
            </span>
          </button>
        </div>
          <div class="flex item-center space-x-6">
              <button
                  v-if="!item.required"
                  @click="$emit('skip', item, selected)"
                  class="inline-flex items-center justify-center py-2 space-x-1 text-sm font-bold text-white rounded-full focus:outline-none"
              >
            <span class="text-black dark:text-white">{{
                    t("input.skip")
                }}</span>
                  <SkipIcon />
              </button>
              <button
                  @click="$emit('close')"
                  class="inline-flex items-center justify-center space-x-1 font-bold text-sm py-2 text-white rounded-full focus:outline-none"
              >
                  <span class="text-black dark:text-white"></span>
                  <BackIcon />
              </button>
          </div>
      </div>
      <!-- Mobile action -->
      <div class="flex flex-col w-full pt-4 space-y-4 md:hidden">
        <div class="flex flex-row w-full">
          <button
            type="button"
            @click="next"
            class="inline-flex items-center justify-center flex-shrink-0 w-full min-w-0 px-8 py-2 text-sm font-bold text-center text-black rounded-full bg-gold-alt focus:outline-none"
          >
            <span v-if="!isLoading">{{ t("input.continue") }}</span>
            <span v-else class="flex flex-row space-x-4"
              ><span>{{ t("input.saving") }}</span>
              <Spinner text-color="text-black"
            /></span>
          </button>
        </div>
        <div class="flex flex-row justify-end">
            <div class="flex item-center space-x-6">
                <button
                    v-if="!item.required"
                    @click="$emit('skip', item, selected)"
                    class="inline-flex items-center justify-center py-2 space-x-1 text-sm font-bold text-white rounded-full focus:outline-none"
                >
            <span class="text-black dark:text-white">{{
                    t("input.skip")
                }}</span>
                    <SkipIcon />
                </button>
                <button
                    @click="$emit('close')"
                    class="inline-flex items-center justify-center space-x-1 font-bold text-sm py-2 text-white rounded-full focus:outline-none"
                >
                    <span class="text-black dark:text-white"></span>
                    <BackIcon />
                </button>
            </div>
        </div>
      </div>
    </form>

    <!-- Tooltip -->
    <tooltip-modal
      :show="showTooltip && item.tooltip.length"
      :tooltip="item.tooltip"
      @close="showTooltip = !showTooltip"
    />
    <!-- End tooltip -->

    <!-- Error -->
    <error-modal
      :show="showError"
      :error="error"
      @close="
        showError = !showError;
        error = '';
      "
    />
    <!-- End Error -->
  </div>
</template>

<script>
import { computed, reactive, toRefs } from "vue";
import { useI18n } from "vue-i18n";
import Twitter from "./Twitter";
import SkipIcon from "../icons/SkipIcon";
import BackIcon from "../icons/BackIcon";
import ReturnIcon from "../icons/ReturnIcon";

export default {
  name: "Social",
  components: { ReturnIcon, SkipIcon, Twitter, BackIcon },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const answer = computed(() => props.item.answer);
    const { t } = useI18n();
    const state = reactive({
      showTooltip: false,
      showError: false,
      error: "",
      selected: answer.value
        ? answer.value.answer
        : {
            fb: "",
            tw: "",
            in: "",
            ig: "",
          },
    });

    const next = () => {
      if (
        props.item.required &&
        (state.selected === null ||
          state.selected === "" ||
          state.selected.length === 0)
      ) {
        state.showError = true;
        state.error = t("input.required");
        return;
      }
      emit("next", props.item, state.selected);
    };
    return {
      ...toRefs(state),
      t,
      next,
    };
  },
};
</script>
